import React from "react";
import Styles from "../ClosePopup/ClosePopup.module.css";
import { CircularProgress, Modal } from "@mui/material";
import { Close } from "@mui/icons-material";
import { ReactComponent as ErrorIcon } from "../../../../assets/images/IconError.svg";

const ClosePopup = ({ open, handleClose, onConfirm, loading = false }) => {
  return (
    <div>
      <>
        <Modal open={open} onClose={handleClose}>
          <div className={` ${Styles.createEditModalCont}`}>
            <div className={`headingText  ${Styles.withdrawText}`}>Close</div>
            <div
              style={{ backgroundColor: " #fffffff0;" }}
              className={Styles.headerSection}
            >
              <div>
                <ErrorIcon style={{ width: "60px", height: "60px" }} />
              </div>
              <span>
                Are you sure want to{" "}
                <span
                  style={{
                    fontWeight: "500",
                    color: "var(--warning-shade-text)",
                  }}
                >
                  close
                </span>
              </span>
              <span>this banking transaction?</span>
            </div>
            <div className={Styles.buttonSection}>
              <div
                onClick={handleClose}
                style={{ cursor: "pointer" }}
                className={Styles.onHoverButton}
              >
                <span
                  // className={Styles.onHoverButton}
                  style={{ cursor: "pointer" }}
                >
                  No
                </span>
              </div>
              <div
                onClick={!loading ? onConfirm : null}
                style={{ cursor: "pointer" }}
                className={Styles.onHoverButton}
              >
                <div
                  style={{
                    cursor: loading ? "default" : "pointer",
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  {loading ? (
                    <>
                      <span
                        style={{
                          color: "var(--fourth-color-text",
                          fontWeight: "400",
                        }}
                      >
                        Processing...
                      </span>
                    </>
                  ) : (
                    "Yes"
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </>
    </div>
  );
};

export default ClosePopup;
